/**
 * Main Application Entry Point
 *
 * Renders Dr. Herança routes and theme.
 */

import { useRoutes } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import React from 'react';

import { activeTenant, activeTenantConfig } from './drheranca';
import { GoogleTag } from './drheranca/components/GoogleTag';

import ThemeProvider from './core/theme/ThemeProvider';
import { ConfigProvider } from './core/config';

const App = () => {
  const content = useRoutes(activeTenant.routes);
  const themeName = activeTenantConfig?.theme?.name;

  return (
    <ConfigProvider config={activeTenantConfig}>
      <GoogleTag />
      <ThemeProvider themeName={themeName}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          {content}
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </LocalizationProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default App;
